import { LayoutDirection } from '@crema/constants/AppEnums';
import defaultConfig from '@crema/constants/defaultConfig';
import PropTypes from 'prop-types';
import { createContext, useContext, useEffect, useMemo, useState } from 'react';
import {
    useThemeActionsContext,
    useThemeContext,
} from './ThemeContextProvider';

const LocaleContext = createContext();
const LocaleActionsContext = createContext();

export const useLocaleContext = () => useContext(LocaleContext);

export const useLocaleActionsContext = () => useContext(LocaleActionsContext);

const LocaleContextProvider = ({ children }) => {
    const [locale, setLocale] = useState(defaultConfig.locale);
    const { theme } = useThemeContext();
    const { updateTheme } = useThemeActionsContext();

    const updateLangDir = () => {
        if (
            defaultConfig.rtlLocale.includes(locale.locale) &&
            theme.direction === LayoutDirection.LTR
        ) {
            updateTheme({
                ...theme,
                direction: LayoutDirection.RTL,
            });
        } else if (
            !defaultConfig.rtlLocale.includes(locale.locale) &&
            theme.direction === LayoutDirection.RTL
        ) {
            updateTheme({
                ...theme,
                direction: LayoutDirection.LTR,
            });
        }
    };

    useEffect(() => {
        updateLangDir();
    }, [locale]);

    const values = useMemo(
        () => ({
            locale,
            rtlLocale: defaultConfig.rtlLocale,
        }),
        [locale],
    );

    const actions = useMemo(
        () => ({
            setLocale,
        }),
        [setLocale],
    );

    return (
        <LocaleContext.Provider value={values}>
            <LocaleActionsContext.Provider value={actions}>
                {children}
            </LocaleActionsContext.Provider>
        </LocaleContext.Provider>
    );
};

export default LocaleContextProvider;

LocaleContextProvider.propTypes = {
    children: PropTypes.node.isRequired,
};
